import React from 'react';
import { renderToString } from 'react-dom/server';

import { FilePowerpointIcon } from '../../../icon/regular';
import {
  BaseSaveInstructionData,
  InstructionActionTooltip,
  InstructionCSSClasses,
  InstructionEvent,
} from '../types';
import InlineInstruction from '../base-instruction/InlineInstruction';
import { addInstructionEvent, emitInstructionEvent } from '../utils';

class DocumentInstruction extends InlineInstruction {
  protected static title = 'Document page';

  get icon() {
    return renderToString(<FilePowerpointIcon style={{ height: 20 }} />);
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.DOCUMENT_PAGE_INSTRUCTION_WRAPPER,
      content: InstructionCSSClasses.DOCUMENT_PAGE_INSTRUCTION_CONTENT,
      action: InstructionCSSClasses.DOCUMENT_PAGE_INSTRUCTION_ACTION,
    };
  }

  openModal(instructionId: string): void {
    this.initEvents();
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_DOCUMENT_PAGE_INSTRUCTION_MODAL,
      { instructionId, isInline: true },
    );
  }

  getTooltip(tooltip: string): string {
    return `${InstructionActionTooltip.documentPage}: ${tooltip}`;
  }

  initEvents() {
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_DOCUMENT_PAGE_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SET_DOCUMENT_PAGE_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  removeEvents() {
    this.api.events.off(
      InstructionEvent.SAVE_DOCUMENT_PAGE_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    this.api.events.off(
      InstructionEvent.SET_DOCUMENT_PAGE_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  saveInstruction(data: BaseSaveInstructionData) {
    if (!this.isActive) {
      this.wrap(data);
    }
    this.removeEvents();
  }

  cancel() {
    this.setSelection();
    this.removeEvents();
  }
}

export default DocumentInstruction;
